import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCultivo } from "../hooks/useCultivo";
import Swal from "sweetalert2";

export const CultivoTable = ({
  onAddingClick,
  onEditingClick,
  cultivo,
  getCultivo,
}) => {
  const { deleteCultivo } = useCultivo();

  const deactivateCultivo = (id_cultivo, estatus) => {
    let estado = "activar";
    if (estatus === 1) {
      estado = "desactivar";
    }
    Swal.fire({
      icon: "info",
      title: `¿Desea ${estado} el cultivo?`,
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: estado.charAt(0).toUpperCase() + estado.slice(1),
      confirmButtonColor: "green",
      cancelButtonColor: "red",
      showLoaderOnConfirm: true,
      backdrop: true,
      preConfirm: async () => {
        try {
          await deleteCultivo(id_cultivo, estatus === 1 ? 0 : 1);
        } catch (error) {
          Swal.showValidationMessage(`${error}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((res) => {
      if (res.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: `Estatus actualizado`,
          timer: 1500,
        });
        getCultivo();
      }
    });
  };

  return (
    <div className="table-respoinsive" style={{ flex: 1 }}>
      <table className="table">
        <thead>
          <tr>
            <th>CULTIVO</th>
            <th>ACCIÓN</th>
            <th>
              <button onClick={onAddingClick} className="btn btn-success">
                Nuevo cultivo
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {cultivo.map((item) => (
            <tr key={item.idcultivo}>
              <td>{item.cultivo}</td>
              <td>
                {item.estatus === 1 && (
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => onEditingClick(item.idcultivo)}
                  >
                    <FontAwesomeIcon icon="fa-solid fa-pen" />
                  </button>
                )}{" "}
                <button
                  className={`btn btn-sm ${
                    item.estatus === 1
                      ? "btn-outline-danger"
                      : "btn-outline-success"
                  }`}
                  onClick={() =>
                    deactivateCultivo(item.idcultivo, item.estatus)
                  }
                >
                  <FontAwesomeIcon icon="fas fa-power-off" />
                </button>
              </td>
              <td></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
